module.exports = __webpack_public_path__ + "static/media/trough.1831d779.svg";